module.exports = __webpack_public_path__ + "static/media/maximize.01bc7b95.svg";